var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84467 12.1553C1.55178 11.8624 1.55178 11.3876 1.84467 11.0947L6.84467 6.09467C7.13756 5.80178 7.61244 5.80178 7.90533 6.09467C8.19822 6.38756 8.19822 6.86244 7.90533 7.15533L4.18566 10.875H17.375C17.7892 10.875 18.125 11.2108 18.125 11.625C18.125 12.0392 17.7892 12.375 17.375 12.375H4.18566L7.90533 16.0947C8.19822 16.3876 8.19822 16.8624 7.90533 17.1553C7.61244 17.4482 7.13756 17.4482 6.84467 17.1553L1.84467 12.1553Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 13.875V19.625C12.375 20.7296 13.2704 21.625 14.375 21.625H20.375C21.4796 21.625 22.375 20.7296 22.375 19.625V3.625C22.375 2.52043 21.4796 1.625 20.375 1.625H14.375C13.2704 1.625 12.375 2.52043 12.375 3.625V9.375H17.375C18.6176 9.375 19.625 10.3824 19.625 11.625C19.625 12.8676 18.6176 13.875 17.375 13.875H12.375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.828fc9066be71092f383f74a0c8fe3f6.svg";
export { ForwardRef as ReactComponent };